import { flow } from 'fp-ts/function';
import { map, partial } from 'lodash/fp';
import { getOrEmptyArray } from '@mews/fp';
import { type } from '@mews/framework';
import GeneralApiComponent from '../generalApiComponent';
import createRequest from './misc/createRequest';
import searchable from './traits/searchable';

const BASE_URL = '/locations';
const onSuccess = flow(
    getOrEmptyArray('locations'),
    map((location) => ({
        // @ts-expect-error $TSFixMeError: Spread types may only be created from object types.
        ...location,
        id: `${(location as $TSFixMe).coordinates.latitude}${(location as $TSFixMe).coordinates.longitude}${
            (location as $TSFixMe).freeformAddress
        }`,
    }))
);

export default function LocationsComponent(apiComponent: $TSFixMe) {
    type.check(apiComponent, GeneralApiComponent);
    const request = createRequest(apiComponent.request, BASE_URL);
    // @ts-expect-error $TSFixMeError: Argument of type '(a1: null | undefined) => any[]' is not assignable to parameter of type 'LodashIdentity'.
    return type.create(LocationsComponent, searchable(partial(request, ['/search']), onSuccess));
}
